import * as React from 'react';
import * as Classes from '../common/classes';
import {
  DividerIntent,
  DividerMode,
  ElementOf,
  IProps,
  tuple,
} from '../common/props';
import classNames from 'classnames';

export const DividerTypes = tuple('line', 'dot');
export type DividerType = ElementOf<typeof DividerTypes>;

export interface IDividerProps extends IProps {
  /**
   * Pokud chceme hoprizontální, nastaví se na true, ve výchozím stavu je divider vertikální (false).
   */
  horizontal?: boolean;
  /**
   * Typ zobrazení oddělovače, výchozí je line.
   */
  type?: DividerType;
  /**
   * Intent oddělovače.
   */
  intent?: DividerIntent;
  mode?: DividerMode;
}

export type DividerProps = IDividerProps;

export class Divider extends React.PureComponent<DividerProps> {
  render() {
    const {
      className,
      mode = 'default',
      type = 'line',
      horizontal,
      intent,
      ...other
    } = this.props;

    if (type === 'line') {
      return (
        <div
          {...other}
          className={classNames(
            className,
            Classes.DIVIDER,
            Classes.DIVIDER_TYPE_LINE,
            {
              [Classes.DIVIDER_DEFAULT]: !intent || intent === 'default',
              [Classes.DIVIDER_SECONDARY]: intent === 'secondary',
              [Classes.DIVIDER_WARNING]: intent === 'warning',
            },
            {
              [Classes.DIVIDER_HORIZONTAL]: horizontal,
              [Classes.DIVIDER_VERTICAL]: !horizontal,
            },
            {
              [Classes.DIVIDER_MODE_DEFAULT]: mode === 'default',
              [Classes.DIVIDER_MODE_DASHED]: mode === 'dashed',
            }
          )}
        />
      );
    } else {
      return (
        <span
          {...other}
          className={classNames(
            className,
            Classes.DIVIDER,
            Classes.DIVIDER_TYPE_DOT,
            {
              [Classes.DIVIDER_DEFAULT]: !intent || intent === 'default',
              [Classes.DIVIDER_SECONDARY]: intent === 'secondary',
              [Classes.DIVIDER_WARNING]: intent === 'warning',
            }
          )}
        >
          •
        </span>
      );
    }
  }
}
